<template>
    <v-row>
        <v-col cols="12">
            <div>
                <v-btn @click="change = !change" class="change-btn default-btn">Cambiar de Producto</v-btn>
            </div>
        </v-col>
        <v-bottom-sheet v-model="change">
            <v-sheet class="text-center" >
                <div class="d-flex justify-end pt-2 pl-4 pr-4">
                    <v-btn style="text-transform: none;" text color="#999" @click="change = !change" >
                        <v-icon small class="mr-2">mdi-close</v-icon>Cerrar
                    </v-btn>
                </div>
                <div class="py-3 d-none d-md-block">
                    <div class="products-btns-wrapper" v-show="change">
                        <template v-for="group in chosenProducts">
                            <h3 v-if="group.header" class="category-header">{{ group.header }}</h3>
                            <v-btn 
                                v-for="product in group.products" 
                                :key="product.type" 
                                @click="handleProductClick(group, product)"
                                class="default-btn"
                                :class="{ active: isActiveProduct(group, product.type)}"                                >
                                {{product.button}}
                                <HelpTooltip class="ml-auto" v-if="product.help" :text="product.help" color="rgba(0,0,0,.5)" />
                            </v-btn>
                        </template>
                    </div>
                </div>
                <div style="min-height:60vh" class="py-15 px-10 d-block d-md-none">
                    <v-select 
                        no-data-text="Sin datos"
                        label="Producto"
                        v-model="selectedProduct"
                        :items="flattenedChosenProducts"
                        item-text="button"
                        item-value="type"
                        @change="handleSelectChange"
                        outlined
                        color="var(--helloteca-main)"
                    />
                </div>
            </v-sheet>
        </v-bottom-sheet>
    </v-row>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import HelpTooltip from './HelpTooltip';

    export default {
        components:{
            HelpTooltip
        },
        data() {
            return {
                change: false,
                selectedProduct: ''
            }
        },
        methods: {
            ...mapMutations([
                'CHANGE_ACTIVE_PRODUCT'
            ]),
            handleProductClick(group, product) {
                let productGroup = group.header 
                ? group.header.toLowerCase() === 'hipotecas' ? 'hipoteca' : 'prestamo' : 'hipoteca';
                this.callChangeActiveProduct(productGroup, product.type);
            },            
            isActiveProduct(group, productType) {
                if (group.header) {
                    return group.header.toLowerCase() === 'hipotecas'? this.preScoring.Vivienda.tipo_vivienda === productType : this.preScoring.Vivienda.tipo_prestamo === productType;
                } else {
                    // Si no hay header (usando this.products)
                    return this.preScoring.Vivienda.tipo_vivienda === productType;
                }
            },
            getProductGroupType(group) {
                return group.header === 'Hipotecas' ? 'hipoteca' : 'prestamo';
            },
            callChangeActiveProduct(type, value) {
                if (!type) type = 'hipoteca';
                this.CHANGE_ACTIVE_PRODUCT({ type, value });
                this.change = false;
            }, 
            handleSelectChange(value) {
                const productType = this.flattenedChosenProducts.find(product => product.type === value).type;
                const productGroup = this.chosenProducts.find(group => group.products.some(product => product.type === value));
                const groupType = productGroup ? this.getProductGroupType(productGroup) : 'hipoteca';
                
                this.callChangeActiveProduct(groupType, productType);
            }
        },

        computed: {
            ...mapState([
                'preScoring',
                'products',
                'brokerData'
            ]),
            chosenProducts() {
                const groups = [];
                if (this.brokerData && this.brokerData.portal_data && this.brokerData.portal_data.productos) {
                    if (this.brokerData.portal_data.productos.hipotecas && this.brokerData.portal_data.productos.hipotecas.length > 0) {
                        groups.push({
                            header: 'Hipotecas',
                            products: this.brokerData.portal_data.productos.hipotecas
                        });
                    }
                    if (this.brokerData.portal_data.productos.prestamos && this.brokerData.portal_data.productos.prestamos.length > 0) {
                        groups.push({
                            header: 'Préstamos',
                            products: this.brokerData.portal_data.productos.prestamos
                        });
                    }
                } else {
                    groups.push({
                        products: this.products
                    });
                }
                return groups;
            },
            //esta función hace una lista en un solo array del resultado de la función de aca arriba
            flattenedChosenProducts() {
                return this.chosenProducts.length === 0 ? this.products : this.chosenProducts.reduce((acc, group) => acc.concat(group.products), []);            }
        },
    }
</script>


<style lang="scss" scoped>
    .default-btn{
        font-family: 'montserrat' !important;
        letter-spacing: initial;
        justify-content: center;
        align-items: center;
        border: 3px solid #E9ECEE;
        border-radius: 10px;
        font-size: 15px;
        background-color: #fff !important;
        padding: 10px 20px !important;
        color: #90A4AE;
        font-weight: 600;
        min-height: 70px;
        vertical-align: super;
        box-shadow: none !important;
        text-transform: none;
        height: auto !important;
        transition: all .2s;
        @media (max-width: 600px) {
            font-size: 12px;
        }
        &:hover{
            background: var(--helloteca-main) !important;
            color:#FFF !important;
            border-color: var(--helloteca-main) !important;
            transition: all .2s;
        }
        &.active{
            border: 2px solid var(--helloteca-main) !important;
            color: #333;
        }
        &.change-btn{
            min-height: auto;
            border-radius: 50px;
            padding: 11px 50px !important;
            height: initial !important;
            border: 2px solid #E9ECEE;
            font-weight: 500;
            color: #333;
            @media (max-width: 600px) {
                padding: 10px 35px !important;
            }
        }
    }
    .category-header {
        grid-column: span 3;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        margin: 10px 0;
        padding: 5px 0;
    }
    .products-btns-wrapper {
        padding: 0px 7% 30px;
        display: grid;
        grid-gap: 10px;
        grid-template-columns: repeat(3, 1fr);
        grid-auto-rows: minmax(50px, auto);

        @media (max-width: 1150px) {
            grid-template-columns: repeat(2, 1fr);
        }
        @media (max-width: 900px) {
            grid-template-columns: repeat(2, 1fr);
        }
        @media (max-width: 600px) {
            grid-template-columns: repeat(1, 1fr);
        }
    }
</style>